import React from "react";

interface MapPreviewProps {
  embedLink: string;
  loading: boolean;
  onLoad: () => void;
}

export const MapPreview: React.FC<MapPreviewProps> = ({
  embedLink,
  loading,
  onLoad,
}) => {
  if (!embedLink) return null;

  return (
    <div className="mt-4">
      {loading && (
        <div className="text-center text-gray-600 mb-2">Loading map...</div>
      )}
      <div className="w-full h-[450px]">
        <iframe
          src={embedLink}
          width="100%"
          height="100%"
          style={{ border: 0 }}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Google Maps"
          onLoad={onLoad}
        ></iframe>
      </div>
    </div>
  );
};
